import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Credit Details</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
